import { Box, styled, Typography } from '@mui/material';

export const CoverChip = styled(Box)(({ theme }) => ({
  height: '24px',
  maxWidth: '55px',
  width: '100%',
  background: theme.palette.case.neutral.n0,
  borderRadius: '4px',
  padding: '2px 8px',
  position: 'absolute',
  left: '4px',
  top: '4px',
}));

export const ActionMenuContainer = styled(Box)(() => ({
  position: 'absolute',
  right: '4px',
  top: '4px',
}));

export const CoverText = styled(Typography)(({ theme }) => ({
  color: theme.palette.case.neutral.n700,
}));

export const AttachmentsItemCardContentContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  border: `0.5px solid ${theme.palette.case.neutral.n200}`,
  borderRadius: '5px',
  '.attachment-icon-btn': {
    display: 'none',
    opacity: 0,
    position: 'absolute',
    top: '8px',
    right: '8px',
  },
  '.action-menu-btn': {
    display: 'none',
  },
  '&:hover': {
    transition: 'all 0.3s',
    borderColor: theme.palette.case.primary.p500,
    '.attachment-icon-btn': {
      opacity: 1,
      display: 'block',
    },

    '.action-menu-btn': {
      display: 'block',
      opacity: 1,
    },

    img: {
      filter: 'brightness(80%)',
    },
  },

  img: {
    width: '100%',
    borderRadius: '5px',
    objectFit: 'fill',

    transition: 'filter 0.3s',
  },

  [theme.breakpoints.down('sm')]: {
    '.attachment-icon-btn': {
      display: 'block',
      opacity: 1,
    },

    '.action-menu-btn': {
      display: 'block',
      opacity: 1,
    },
  },
}));

export const AttachmentsItemWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => !['isLoading'].includes(prop),
})<{ isLoading: boolean }>(({ isLoading }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  cursor: isLoading ? 'default' : 'pointer',
}));
